import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Button } from 'elc-buttons';
import { ContentSpacing } from 'elc-base-theme';
import { lazyInject, serviceNames } from '../../../service-setup/diContainer';
import { ProductShadesSidebarViewController } from '../../controllers/ProductShadesSidebarViewController';
import { Shade } from '../../domain/entities/Shade';
import { SHADES_SIDE_BAR_BUTTON } from '../../constants/DataTestIdAttributes';
import { classes } from '../../utils/Classes';

interface IStyledSquareIcon {
    selectedHexValue?: string;
}

export interface IProductShadesSidebarButton {
    selectedShade: Shade;
    className?: string;
}

const StyledButton = styled(Button)`
    width: 100%;
    display: inline-block;
    padding: ${ContentSpacing.space16};
    cursor: pointer;
`;

const StyledSquareIcon = styled.div`
    padding-left: ${ContentSpacing.space16};
    margin-left: ${ContentSpacing.space16};
    width: 16px;
    height: 16px;
    background-color: ${({ selectedHexValue }: IStyledSquareIcon) => selectedHexValue};

    [dir='rtl'] & {
        padding-left: 0;
        margin-left: 0;
        padding-right: ${ContentSpacing.space16};
        margin-right: ${ContentSpacing.space16};
    }
`;

const StyledButtonContent = styled.span`
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

const StyledShadeName = styled.div`
    overflow: hidden;
`;

const shadeIcon = (hexValue: string) => <StyledSquareIcon selectedHexValue={hexValue} />;

@observer
export class ProductShadesSidebarButton extends React.Component<IProductShadesSidebarButton> {
    @lazyInject(serviceNames.productShadesSidebarViewController)
    private productShadesSidebarViewController: ProductShadesSidebarViewController;

    public handleShadeViewButtonClick = async () => {
        await this.productShadesSidebarViewController.onProductShadesViewClick(
            this.props.selectedShade
        );
    };

    private productShadesSidebarButtonClassNames = classes(
        'product-shades-view-button',
        this.props.className
    );

    public render() {
        const { selectedShade } = this.props;

        return (
            <StyledButton
                className={this.productShadesSidebarButtonClassNames}
                onClick={this.handleShadeViewButtonClick}
                data-test-id={SHADES_SIDE_BAR_BUTTON}
            >
                <StyledButtonContent>
                    <StyledShadeName>{selectedShade.name}</StyledShadeName>
                    {shadeIcon(selectedShade.hexVal)}
                </StyledButtonContent>
            </StyledButton>
        );
    }
}
